module.exports = __webpack_public_path__ + "static/media/iguazu-falls-6.6992b1c5.jpg";